export default "__VITE_ASSET__7fd448f3__"